import ModalController from './ModalController'
import Confirm from '../dialog/Confirm.vue'

import utils from '../../utils'

let installed = false

const ModalPlugin = {
  install (Vue, options = {}) {
    if (installed) {
      return
    }

    /**
     * 初始化组件的公共监听器
     ******************************************************
     * 监听 toggle
     * @param {String}  name    弹出框标识
     * @param {Boolean} state   弹出框的显示状态
     * @param {Object}  params  额外参数
     */
    this.event = new Vue()
    this.modalController = null

    // installComponent(Vue)
    installed = true

    /**
     * 创建 modal controller 容器
     */
    let $modalWrapper = document.querySelector('#gkui-modal-controller')

    if (!$modalWrapper) {
      $modalWrapper = document.createElement('div')

      $modalWrapper.id = 'gkui-modal-controller'

      document.body.appendChild($modalWrapper)
    }
    Vue.prototype.$modal = {
      /**
       * 初始化弹出框的内置控制器
       * 所有弹出框的方法通过当前的控制器触发
       */
      _setModalContainer (modalController) {
        ModalPlugin.modalController = modalController
      },
      /**
       * 手动控制显示遮罩层
       * 调用方式 this.$modal.showLayer()
       */
      showLayer () {
        ModalPlugin.modalController.showLayer()
      },
      /**
       * 手动控制关闭遮罩层
       * 调用方式 this.$modal.hideLayer()
       */
      hideLayer () {
        ModalPlugin.modalController.hideLayer()
      },
      /**
       * 显示弹出框
       * 当 modal 参数为弹出框标识时，执行显示弹出框操作
       * 当 modal 参数为 component 组件式, 执行添加到 modal 列表, 通过 config.auto 判断是否自动显示
       * @param  {String|Component}  modal  [string]    弹出框的标识
       *                                    [component] 弹出框 component
       * @param  {Object}    paramsOrProps  弹出框的数据，自动绑定到 component
       * @param  {Object}    config         弹出框的配置
       * @param  {String}    config.name    弹出框的标识，当 modal 为 name 时，此参数可为空
       * @param  {Boolean}   config.auto    是否自动显示
       * @param  {Boolean}   config.layer   是否使用遮罩层
       */
      show (modal, paramsOrProps = {}, config = {}) {
        if (typeof modal === 'string') {
          ModalPlugin.event.$emit('toggle', modal, true, paramsOrProps)
        } else {
          if (ModalPlugin.modalController) {
            if (!config.name) {
              console.warn('未设置弹出框标识')
              return
            }

            ModalPlugin.modalController.add(modal, paramsOrProps, config)
          } else {
            console.warn('弹出框初始化失败, 请查看是否初始化控制器')
          }
        }
      },
      /**
       * 关闭弹出框
       * @param  {String}  name    弹出框的标识
       * @param  {Object}  params  传出的数据
       */
      hide (name, params) {
        ModalPlugin.event.$emit('toggle', name, false, params)
      },
      /**
       * 默认弹出框 -- 消息框
       * @param  {Object}  option  配置
       * @param  {String}  option.title    标题
       * @param  {String}  option.message  消息文本
       */
      message (option = {}) {
        option.value = true
        option.type = 'message'
        option.name = `message${utils.guid()}`
        option.autoClose = !option.notAuto

        return new Promise((resolve, reject) => {
          ModalPlugin.modalController.add(Confirm, option, { name: option.name })
          ModalPlugin.event.$once('closeMessage', res => {
            resolve(res)
          })
        })
      },
      /**
       * 默认弹出框 -- 确认框
       * @param  {Object}  option  配置
       * @param  {String}  option.title    标题
       * @param  {String}  option.message  消息文本
       */
      confirm (option = {}) {
        option.value = true
        option.type = 'confirm'
        option.name = `confirm${utils.guid()}`

        return new Promise((resolve, reject) => {
          ModalPlugin.modalController.add(Confirm, option, { name: option.name })
          ModalPlugin.event.$once('closeMessage', res => {
            resolve(res)
          })
        })
      }
    }

    new Vue({
      render: h => h(ModalController)
    }).$mount('#gkui-modal-controller')
  }
}

// function installComponent (Vue) {
//   const components = {
//     'ms-dialog': msDialog,
//     'ms-message': msMessage
//   }

//   Object.keys(components).forEach((id) => {
//     Vue.component(id, components[id])
//   })
// }

export default ModalPlugin
// export { msMessage }
